import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';

// UV Pulser Firebase & Google Cloud Configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyD3hjDFZHFzURyT2s52x-wPTPng67DxHEQ",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "uvpulser-web.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "uvpulser-web",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "uvpulser-web.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "962194029140",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:962194029140:web:ef588941a70c94c9accbc1"
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const db = getFirestore(app);

export interface ContactInquiry {
  id?: string;
  name: string;
  email: string;
  organization?: string;
  inquiryType?: string;
  message?: string;
  turnstileToken?: string;
  source?: string;
  status: 'new' | 'contacted' | 'archived';
  createdAt: string;
}

export interface InvestorInquiry {
  id?: string;
  name: string;
  email: string;
  organization?: string;
  investmentQuantum: string;
  message?: string;
  turnstileToken?: string;
  source?: string;
  status: 'new' | 'reviewed' | 'scheduled';
  createdAt: string;
}

const INQUIRIES_STORAGE_KEY = 'uvpulser_inquiries_backup';
const INVESTORS_STORAGE_KEY = 'uvpulser_investors_backup';

export async function saveContactInquiry(inquiry: Omit<ContactInquiry, 'status' | 'createdAt'>): Promise<{ success: boolean; id: string }> {
  const docData: ContactInquiry = {
    ...inquiry,
    status: 'new',
    source: 'uvpulser.com',
    createdAt: new Date().toISOString(),
  };

  try {
    const docRef = await addDoc(collection(db, 'uvpulser_inquiries'), docData);
    return { success: true, id: docRef.id };
  } catch (err) {
    console.warn('Firestore direct write unavailable, saving to resilient local store:', err);
    const existing = JSON.parse(localStorage.getItem(INQUIRIES_STORAGE_KEY) || '[]');
    const fallbackId = `inq-${Date.now()}`;
    existing.unshift({ ...docData, id: fallbackId });
    localStorage.setItem(INQUIRIES_STORAGE_KEY, JSON.stringify(existing));
    return { success: true, id: fallbackId };
  }
}

export async function saveInvestorInquiry(inquiry: Omit<InvestorInquiry, 'status' | 'createdAt'>): Promise<{ success: boolean; id: string }> {
  const docData: InvestorInquiry = {
    ...inquiry,
    status: 'new',
    source: 'uvpulser.com/investor',
    createdAt: new Date().toISOString(),
  };

  try {
    const docRef = await addDoc(collection(db, 'uvpulser_investors'), docData);
    return { success: true, id: docRef.id };
  } catch (err) {
    console.warn('Firestore direct write unavailable, saving to resilient local store:', err);
    const existing = JSON.parse(localStorage.getItem(INVESTORS_STORAGE_KEY) || '[]');
    const fallbackId = `inv-${Date.now()}`;
    existing.unshift({ ...docData, id: fallbackId });
    localStorage.setItem(INVESTORS_STORAGE_KEY, JSON.stringify(existing));
    return { success: true, id: fallbackId };
  }
}

// Google Analytics / Conversion Event Tracking Helper
export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, params);
  }
}
